"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormInputSuffix", {
    enumerable: true,
    get: function() {
        return FormInputSuffix;
    }
});
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
const _FormInputXFix = require("./FormInputXFix");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const FormInputSuffix = /*#__PURE__*/ _react.default.forwardRef((props, ref)=>/*#__PURE__*/ _react.default.createElement(_FormInputXFix.FormInputXFix, {
        type: "suffix",
        ...props,
        ref: ref
    }));
FormInputSuffix.displayName = "FormInputSuffix";

//# sourceMappingURL=FormInputSuffix.js.map